// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
export class Constants
{
  static readonly ApplicationIconResolutionMap = {
    "16": "assets/ApplicationIcon16x16.png",
    "19": "assets/ApplicationIcon19x19.png",
    "24": "assets/ApplicationIcon24x24.png",
    "32": "assets/ApplicationIcon32x32.png",
    "38": "assets/ApplicationIcon38x38.png",
    "48": "assets/ApplicationIcon48x48.png",
    "128": "assets/ApplicationIcon128x128.png"
  };

  static readonly ApplicationIconGrayResolutionMap = {
    "16": "assets/ApplicationIconGray16x16.png",
    "19": "assets/ApplicationIconGray19x19.png",
    "24": "assets/ApplicationIconGray24x24.png",
    "32": "assets/ApplicationIconGray32x32.png",
    "38": "assets/ApplicationIconGray38x38.png",
    "48": "assets/ApplicationIconGray48x48.png",
    "128": "assets/ApplicationIconGray128x128.png"
  };

  static readonly DefaultBadgeDisplayDelay = 1000;

  static readonly MessageToExtensionEventName = "RemotionDmsMessageToExtension";
  static readonly MessageToWebsiteEventName = "RemotionDmsMessageToWebsite";
  static readonly PrimerMessageToExtension = "RemotionDmsPrimerMessageToExtension";
  static readonly PrimerMessageToWebsite = "RemotionDmsPrimerMessageToWebsite";

  static readonly PreviewMessageToExtensionEventName = "RemotionDmsPreviewMessageToExtension";
  static readonly PreviewMessageToWebsiteEventName = "RemotionDmsPreviewMessageToWebsite";
  static readonly PreviewPrimerMessageToExtension = "RemotionDmsPreviewPrimerMessageToExtension";
  static readonly PreviewPrimerMessageToWebsite = "RemotionDmsPrimerPreviewMessageToWebsite";

  static readonly JsonRpcFormat = "json-rpc";
  static readonly LoggingFormat = "logging";

  static readonly LoggingConfigurationPersistKey = "RemotionDms.LoggingConfiguration";
  static readonly RemoteLoggingConfigurationPersistKey = "RemotionDms.RemoteLoggingConfiguration";

  static readonly RemoteLogCacheCapacity = 100;
}